import { useEffect, useState } from 'react';
import { PageConfig } from '../types/config/PageConfig';

type Listener = () => void;

let currentOverride: PageConfig | null = null;
const listeners = new Set<Listener>();

export const pageHeaderOverrideStore = {
  setOverride(config: PageConfig | null) {
    currentOverride = config;
    listeners.forEach(listener => listener());
  },
  getOverride() {
    return currentOverride;
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};

export const usePageHeaderOverride = (): PageConfig | null => {
  const [override, setLocalOverride] = useState(pageHeaderOverrideStore.getOverride());

  useEffect(
    () => pageHeaderOverrideStore.subscribe(() => setLocalOverride(pageHeaderOverrideStore.getOverride())),
    [],
  );

  return override;
};
